import { Controller } from "@hotwired/stimulus"

// Gates /ao-vivo behind a "which game is yours?" picker for referees. The
// choice is remembered per device (not per user — every referee/mesário
// shares one login, so there's no server-side identity to hang this on),
// which is also what referee_game_lock_controller.js reads to strip action
// buttons off every game except the chosen one. See index.html.erb.
//
// Selecting/resetting fires a window event instead of relying on Stimulus's
// connect() lifecycle: this page's game cards are already in the DOM (just
// hidden behind the picker), so nothing here ever gets removed/reinserted
// to make a lock controller's connect() refire on its own.
export default class extends Controller {
  static targets = ["picker", "content"]

  static STORAGE_KEY = "lifSelectedGameId"
  static CHANGE_EVENT = "referee-game-select:change"

  connect() {
    this.render()
  }

  select(event) {
    localStorage.setItem(this.constructor.STORAGE_KEY, event.params.gameId)
    window.dispatchEvent(new Event(this.constructor.CHANGE_EVENT))
    this.render()
  }

  reset() {
    localStorage.removeItem(this.constructor.STORAGE_KEY)
    window.dispatchEvent(new Event(this.constructor.CHANGE_EVENT))
    this.render()
  }

  render() {
    const hasSelection = !!localStorage.getItem(this.constructor.STORAGE_KEY)
    this.pickerTarget.classList.toggle("hidden", hasSelection)
    this.contentTarget.classList.toggle("hidden", !hasSelection)
  }
}
